import api from './api';

export interface GLNData {
  gln: string;
  isLinked: boolean;
  supplierName?: string;
  supplierId?: string;
  articleCount: number;
}

export interface SupplierGLNData {
  _id: string;
  name: string;
  email: string;
  mainGLN?: string;
  kreditorNumber?: string;
  additionalGLNs: Array<{
    gln: string;
    description?: string;
    addedAt: string;
    addedBy?: string;
  }>;
  allGLNs: string[];
  articleCount: number;
  isPrimary?: boolean;
  isLinked?: boolean;
  masterSupplierId?: string;
  linkedSuppliers?: SupplierGLNData[];
  hasLinkedSuppliers?: boolean;
}

// **NEU: LIEFERANTEN VERKNÜPFEN (MasterSupplierId-basiert)**
export const linkSuppliers = async (primarySupplierId: string, linkedSupplierId: string): Promise<{
  success: boolean;
  message: string;
  primarySupplier: any;
  linkedSupplier: any;
}> => {
  try {
    console.log('🔗 Linking suppliers:', { primarySupplierId, linkedSupplierId });
    const response = await api.post('/gln-linking/link-suppliers', {
      primarySupplierId,
      linkedSupplierId
    });
    console.log('✅ Link suppliers response:', response.data);
    
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Fehler beim Verknüpfen der Lieferanten');
    }
  } catch (error: any) {
    console.error('❌ Error linking suppliers:', error);
    throw error;
  }
};

// **LIEFERANTEN-VERKNÜPFUNG ENTFERNEN**
export const unlinkSupplier = async (linkedSupplierId: string): Promise<{
  success: boolean;
  message: string;
}> => {
  try {
    console.log('🔗 Unlinking supplier:', { linkedSupplierId });
    const response = await api.post('/gln-linking/unlink-supplier', {
      linkedSupplierId
    });
    console.log('✅ Unlink supplier response:', response.data);
    
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.message || 'Fehler beim Entfernen der Verknüpfung');
    }
  } catch (error: any) {
    console.error('❌ Error unlinking supplier:', error);
    throw error;
  }
};

// **VERFÜGBARE GLN-NUMMERN LADEN**
export const getAvailableGLNs = async (): Promise<GLNData[]> => {
  try {
    console.log('🔄 Loading available GLNs...');
    const response = await api.get('/gln-linking/available-glns');
    console.log('✅ GLNs response:', response.data);
    
    if (response.data.success) {
      return response.data.glns || [];
    } else {
      throw new Error(response.data.message || 'Fehler beim Laden der GLN-Nummern');
    }
  } catch (error) {
    console.error('❌ Error loading available GLNs:', error);
    throw error;
  }
};

// **LIEFERANTEN MIT IHREN GLNS LADEN**
export const getSuppliersWithGLNs = async (): Promise<SupplierGLNData[]> => {
  try {
    console.log('🔄 Loading suppliers with GLNs...');
    const response = await api.get('/gln-linking/suppliers-with-glns');
    console.log('✅ GLN Suppliers response:', response.data);
    
    if (response.data.success) {
      return response.data.suppliers || [];
    } else {
      throw new Error(response.data.message || 'Fehler beim Laden der Lieferanten');
    }
  } catch (error) {
    console.error('❌ Error loading suppliers with GLNs:', error);
    throw error;
  }
};

// **GLN ZU LIEFERANT HINZUFÜGEN**
export const addGLNToSupplier = async (
  supplierId: string, 
  gln: string, 
  description?: string
): Promise<{ success: boolean; message: string; articleCount?: number }> => {
  try {
    console.log('🔄 Adding GLN to supplier...', { supplierId, gln, description });
    const response = await api.post('/gln-linking/add-gln', {
      supplierId,
      gln,
      description
    });
    console.log('✅ Add GLN response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ Error adding GLN to supplier:', error);
    throw error;
  }
};

// **GLN VON LIEFERANT ENTFERNEN**
export const removeGLNFromSupplier = async (
  supplierId: string, 
  gln: string
): Promise<{ success: boolean; message: string }> => {
  try {
    console.log('🔄 Removing GLN from supplier...', { supplierId, gln });
    const response = await api.post('/gln-linking/remove-gln', {
      supplierId,
      gln
    });
    console.log('✅ Remove GLN response:', response.data);
    
    return response.data;
  } catch (error) {
    console.error('❌ Error removing GLN from supplier:', error);
    throw error;
  }
};
